import { Card, Button } from 'react-bootstrap'
import { Skeleton } from 'antd'

const MitraCardLoading = () => (
  <Card className="mitra-card">
    <Card.Body className="text-center">
      <div className="mb-3">
        <Skeleton.Avatar active size="large" />
      </div>
      <div className="my-3">
        <Skeleton active paragraph={{ rows: 3 }} title={false} />
      </div>
      <div className="my-3 mx-auto w-75">
        <Skeleton.Button active shape="square" block />
      </div>
    </Card.Body>
  </Card>
)
export default MitraCardLoading
